module.exports = __webpack_public_path__ + "static/img/msg_bg.a454f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/msg_bg.png
// module id = HwXQ
// module chunks = 0